import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuthorization } from "../../hooks/useAuthorization";
import Loading from "../../components/loading/Loading";
import Modal from "../../components/modal/Modal";
import MainContainer from "../../components/container/MainContainer";
import LocationHeader from "../../components/header/LocationHeader";
import Table from "../../components/tables/Table";
import { openModal } from "../../features/modalSLice";
import AddMethodType from "./AddMethodType";
import {
  getMethodTypes,
  unsetMethodTypes,
} from "../../features/transactionsSlice";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const MethodType = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const currencies = useSelector((state) => state.transactions.methodTypes);
  const loading = useSelector(
    (state) => state.transactions.load.getMethodTypes
  );
  const { isAuthorized } = useAuthorization();

  const title = "Transaction Types";
  // const links = [{ to: "/countries", name: "Countries" }];

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Name" },
    { id: "country", text: "Action" },
  ];

  const openTypeModal = () => {
    dispatch(openModal(<AddMethodType />));
  };

  useEffect(() => {
    dispatch(getMethodTypes());
    return () => {
      dispatch(unsetMethodTypes());
    };
  }, []);
  if (loading) {
    return <Loading />;
  } else if (loading === loadStatus.loading) {
    return <NetworkError to={location.pathname} />;
  } else
    return (
      <>
        <Modal>{modalContent}</Modal>
        <MainContainer>
          <LocationHeader
            title={title}
            links={[]}
            action={openTypeModal}
            authorized={isAuthorized("settings", "create")}
          />
          <main className="table-container">
            <Table columns={columns} data={currencies} link />
          </main>
        </MainContainer>
      </>
    );
};

export default MethodType;
